import { Col, Row, Text } from '@firsttable/web-components/atoms';
import IconDiscount from '@firsttable/web-components/atoms/Icon/IconDiscount';
import IconDiscovery from '@firsttable/web-components/atoms/Icon/IconDiscovery';
import IconReviews from '@firsttable/web-components/atoms/Icon/IconReviews';
import { countFormat, roundToClosest } from '@firsttable/functions';

type StepProps = {
  icon: typeof IconDiscovery;
  title: string;
  message: string;
};

function Step({ icon: Icon, title, message }: StepProps) {
  return (
    <div className="text-center">
      <Icon mb="25px" />
      <h3 className="mb-3 mt-0 font-sans text-md font-semibold tracking-tight">{title}</h3>
      <Text maxWidth="350px" m="0 auto">
        {message}
      </Text>
    </div>
  );
}

export default function PD6630HowItWorks({
  siteConfig,
}: {
  siteConfig: { restaurantCount?: number | null };
}) {
  return (
    <Row>
      <Col width={[1, 1 / 3]} mb={['35px', 0]}>
        <Step
          icon={IconDiscovery}
          title="Find a restaurant"
          message={`Find a new restaurant to try from over ${countFormat(
            roundToClosest(siteConfig.restaurantCount, 100)
          )} restaurants globally`}
        />
      </Col>
      <Col width={[1, 1 / 3]} mb={['35px', 0]}>
        <Step
          icon={IconReviews}
          title="Book the First Table"
          message="Pay a small booking fee to secure your table."
        />
      </Col>
      <Col width={[1, 1 / 3]}>
        <Step
          icon={IconDiscount}
          title="Enjoy 50% off food!"
          message="Arrive to the booked venue and enjoy the deal"
        />
      </Col>
    </Row>
  );
}
